<template>
  <div class="modal-dialog">
    <div class="modal-content success-pop-up">
      <div class="modal-body">
        <button type="button" class="close resource-close" data-dismiss="modal">
          &times;
        </button>
        <p class="success-message">{{ successMsg }}</p>

        <div class="row">
          <div class="col-2"></div>
          <div class="col-4 button-position">
            <button type="button" class="btn btn-cancel-option" @click="closePopup()">
              Cancel
            </button>
          </div>
          <div class="col-4 button-position">
            <button type="button" class="btn btn-yes-option" @click="deactivateResource()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeactivatePopup",
  props: ["title", "successMsg", "type", "resourceDeleteId"],
  data() {
    return {
      resourceType: this.type,
      resourceId: 1233
    };
  },
  methods: {
    closePopup() {
      if (this.resourceType === "material") {
        window.$("#material-deactivate-pop").modal("hide");
      }
    },
    async deactivateResource() {
      if (this.resourceType === "material") {
        await this.$api.deactivateResourceData(this.resourceDeleteId).then(response => {
          if (response) {
            this.$root.$emit("materialDataResponse");
          }
        });
        window.$("#material-deactivate-pop").modal("hide");
        window.$("#deactivate-material-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.success-pop-up {
  width: 350px;
  height: 240px;
  margin: 0 0 3.1px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}

button.resource-close {
  position: relative;
  left: 7px;
  bottom: 10px;
  font-size: 18px;
}

.success-message {
  font-size: 16px;
  font-weight: bold;
  padding: 26px;
  text-align: center;
  color: #666669;
  font-family: "RobotoRegular";
}

.button-position {
  text-align: center;
}

.btn-cancel-option {
  color: #959fa4;
  width: 90px;
  font-size: 14px;
  font-family: "RobotoRegular";
}

.btn-yes-option {
  background-color: #4c8ce4;
  color: #fff;
  width: 90px;
  font-size: 14px;
  font-family: "RobotoRegular";
}
</style>
